module.exports = __webpack_public_path__ + "img/wetNwild3.4d9afcb4.jpg";